import { defineNuxtPlugin } from 'nuxt/app';
// Nuxt event bus using mitt
import mitt, { type Emitter } from 'mitt';

type Events = {
  [key: string]: any;
};

const emitter: Emitter<Events> = mitt<Events>();

export default defineNuxtPlugin(() => {
  return {
    provide: {
      eventBus: emitter
    }
  };
});
